import {
  chat0,
  cs1,
  cs2,
  chat1,
  chat2,
  chat3,
  chat4,
  chat5,
  chat6,
  chat7,
  chat8,
  chat9,
  chat10,
  chat11,
  chat12,
  chat13,
} from "../assets/whatsapp";

export const chatsData = [
  {
    pp: chat0,
    contact: "Sifiso Codes",
    msg: "Awesome work, Sifiso! 🔥",
    time: "1:15 pm",
    unreadMsgs: null,
  },
  {
    pp: chat1,
    contact: "Tom",
    msg: "Sifiso is the GOAT! 🐐",
    time: "12:15 pm",
    unreadMsgs: 2,
  },
  {
    pp: chat2,
    contact: "Best Friend ❤️",
    msg: "Sifiso you rock! Call you later!",
    time: "11:11 am",
    unreadMsgs: 4,
  },
  {
    pp: chat3,
    contact: "Dad",
    msg: "Proud of you, Sifiso!",
    time: "11:04 am",
    unreadMsgs: null,
  },
  {
    pp: chat4,
    contact: "+00 123 4567890",
    msg: "Is this Sifiso? 😳",
    time: "10:58 am",
    unreadMsgs: null,
  },
  {
    pp: chat5,
    contact: "Code Buddies </>",
    msg: "Sifiso help me fix this bug 😭",
    time: "10:50 am",
    unreadMsgs: 23,
  },
  {
    pp: chat6,
    contact: "Mom",
    msg: "Proud of you, son. ❤️",
    time: "10:35 am",
    unreadMsgs: 2,
  },
  {
    pp: chat7,
    contact: "Johnny",
    msg: "Hahaha Sifiso you're hilarious 😂",
    time: "10:18 am",
    unreadMsgs: null,
  },
  {
    pp: chat8,
    contact: "Boss",
    msg: "Meeting soon, Sifiso!",
    time: "10:02 am",
    unreadMsgs: null,
  },
  {
    pp: chat9,
    contact: "Sarah",
    msg: "Sifiso the exam was tough 😓",
    time: "9:47 am",
    unreadMsgs: 3,
  },
  {
    pp: chat10,
    contact: "Doc 🏥",
    msg: "Hey Sifiso, waiting for your reports!",
    time: "9:41 am",
    unreadMsgs: null,
  },
  {
    pp: chat11,
    contact: "Best Mate",
    msg: "Chilling today, Sifiso? 🍻",
    time: "yesterday",
    unreadMsgs: 3,
  },
  {
    pp: chat12,
    contact: "Little Bro",
    msg: "Sifiso this new game is sick! 🎮",
    time: "yesterday",
    unreadMsgs: 6,
  },
  {
    pp: chat13,
    contact: "Prof. Elizabeth",
    msg: "Sifiso, forgot the homework! 😭",
    time: "yesterday",
    unreadMsgs: null,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 1...",
    time: "yesterday",
    unreadMsgs: null,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 2...",
    time: "yesterday",
    unreadMsgs: 7,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 3...",
    time: "yesterday",
    unreadMsgs: null,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 4...",
    time: "yesterday",
    unreadMsgs: 7,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 5...",
    time: "yesterday",
    unreadMsgs: null,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 6...",
    time: "yesterday",
    unreadMsgs: 7,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 7...",
    time: "yesterday",
    unreadMsgs: null,
  },
  {
    pp: chat4,
    contact: "Testing",
    msg: "Sifiso testing chat 8...",
    time: "yesterday",
    unreadMsgs: 7,
  },
];

export const messagesData = [
  {
    msg: "Hey Sifiso, wassup bro! 👋",
    time: "10:58 am",
    sent: false,
  },
  {
    msg: "This project by Sifiso is firee 🔥",
    time: "10:58 am",
    sent: false,
  },
  {
    msg: "Keep it up, Sifiso! 👍👍👍",
    time: "10:59 am",
    sent: false,
  },
  {
    msg: "Thanks a lot, appreciate it! 😀",
    time: "11:15 am",
    sent: true,
  },
  {
    msg: "Follow Sifiso for more cool stuff! 👌👌",
    time: "11:15 am",
    sent: true,
  },
  {
    msg: "I will! What's your Github, Sifiso?",
    time: "11:28 am",
    sent: false,
  },
  {
    msg: "SifisoDev-web",
    time: "11:36 am",
    sent: true,
  },
  {
    msg: "https://github.com/SifisoDev-web",
    isLink: false,
    time: "11:36 am",
    sent: true,
  },
    
  {
    img: cs2,
    time: "11:56 am",
    sent: true,
  },
  {
    msg: "Niceeee channel, Sifiso! 🔥💯",
    time: "12:35 pm",
    sent: false,
  },
  {
    msg: "I'll watch all your videos, Sifiso 😉",
    time: "12:35 pm",
    sent: false,
  },
  {
    msg: "Awesome, thanks for the support! 🙌",
    time: "1:15 pm",
    sent: true,
  },
];
